import { MedicareConsent } from '@/consent/medicare/domain/MedicareConsent';
import { MedicareConsentRepository } from '@/consent/medicare/domain/MedicareConsentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { ServicesApiResponse } from '@hfc/ui-core';

export class UpdateConsentReferenceIdUseCase implements UseCase<MedicareConsent, ServicesApiResponse> {

  private repository: MedicareConsentRepository;

  public constructor (repository: MedicareConsentRepository) {
    this.repository = repository;
  }

  public async run (consentForm: MedicareConsent): Promise<ServicesApiResponse> {
    return await this.repository.updateReferenceId(consentForm);
  }

}
